import React from "react";

const NoResults = () => {
    return (<div className={"no-results-msg"}><h1>Loading...</h1></div>)
};

export default NoResults;
